import styled from "styled-components";
import { mediaMax } from "../../../../styles/mediaQueries";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${mediaMax.tabletLandscape`
    flex-direction: column;
  `};
`;

export const Nav = styled.div`
  width: 300px;
  padding: 0;
  margin-top: 26px;
  border-top: 2px solid rgba(0,0,0,.2);
  ${mediaMax.tabletLandscape`
    width:60%;
  `};
  ${mediaMax.tablet`
    width:100%;
  `};

  h3 {
    font-family: "SangBleu Kingdom",sans-serif;
    font-size: 21px;
    line-height: 28px;
    margin: 0 0 8px 0;
    padding-top: 10px;
  }

  ul {
    padding: 0;
    margin: 0;

    li {
      list-style: none;
      font-family: 'Apercu', 'sans-serif';
      font-size: 14px;
      line-height: 32px;
      letter-spacing: -0.3px;
      b {
        font-family: "SangBleu Kingdom",sans-serif;
      }
    }
  }
`;

export const Map = styled.div`
  width: calc(98% - 360px);

  ${mediaMax.tabletLandscape`
    width: 100%;
    height: 58.3vh;
    margin-top: 60px;
  `};
  ${mediaMax.phoneXL`
    width: 100%;
    height: 50vh;
    margin-top: 0;
    margin-bottom: 24px;
  `};

  img {
    width: 100%;
  }
`;
